import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../../../axios/axiosInstance';

const BRAND = '#1D2C7B';

const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: 38,
        borderRadius: 8,
        fontSize: 14,
        boxShadow: 'none',
        borderColor: state.isFocused ? BRAND : '#e2e8f0',
        ':hover': { borderColor: BRAND },
    }),
    placeholder: (base) => ({ ...base, color: '#94a3b8', fontSize: 14 }),
    singleValue: (base) => ({ ...base, color: '#334155' }),
    multiValue: (base) => ({ ...base, backgroundColor: '#f1f5f9', borderRadius: 6 }),
    multiValueLabel: (base) => ({ ...base, color: BRAND, fontSize: 12 }),
    indicatorSeparator: (base) => ({ ...base, backgroundColor: '#e2e8f0' }),
    menu: (base) => ({
        ...base,
        borderRadius: 8,
        border: '1px solid #e2e8f0',
        boxShadow: 'none',
        fontSize: 14,
        zIndex: 30,
    }),
    option: (base, state) => ({
        ...base,
        fontSize: 14,
        color: state.isSelected ? '#ffffff' : '#334155',
        backgroundColor: state.isSelected ? BRAND : state.isFocused ? '#f1f5f9' : '#ffffff',
    }),
};

export default function RolesList({ value, onChange }) {
    const { t } = useTranslation();
    const [roles, setRoles] = useState([]);

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await axiosInstance.get("/admin/roles");
            const rolesData = response.data.data.map(role => ({ label: role.name, value: role.id }));
            setRoles(rolesData);
        } catch (error) {
            console.error("Error fetching roles:", error);
        }
    };

    const handleChange = selectedOption => {
        // Преобразуйте выбранный объект в массив
        onChange(Array.isArray(selectedOption) ? selectedOption : [selectedOption]);
    };

    return (
        <Select
            options={roles}
            value={value}
            onChange={handleChange}
            placeholder={t('roles.select')}
            className="w-full"
            styles={selectStyles}
        />
    );
}
